<script>
import { mapActions } from 'vuex'
const APPTITLE = process.env.VUE_APP_TITLE || ''

export default {
  data() {
    return {
      version: 'loading...'
    }
  },

  computed: {
    appTitle() {
      return APPTITLE
    }
  },

  async mounted() {
    await this.loadConfig()
  },

  methods: {
    ...mapActions('auth', ['updateUserAgreementsModals']),

    async loadConfig() {
      try {
        const response = await fetch('/config/app-config.json')
        if (response.ok) {
          const config = await response.json()
          this.version = config.version || 'dev'
        } else {
          this.version = 'dev'
        }
      } catch (error) {
        console.warn('Failed to load runtime config, using fallback:', error.message)
        this.version = 'dev'
      }
    },

    showPrivacyPolicyModal() {
      this.updateUserAgreementsModals({ showPrivacy: true })
    },

    showTermsAndConitionsModal() {
      this.updateUserAgreementsModals({ showTerms: true })
    },
  },
}
</script>
<template>
  <footer class="text-white bg-primary p-2 footer font-weight-bold">
    <b-row class="mx-0">
      <b-col
        cols="4"
        class="pl-0"
      >
        <span
          class="modal-link"
          @click="showTermsAndConitionsModal"
        >
          Terms &amp; Conditions |
        </span>
        <span
          class="modal-link"
          @click="showPrivacyPolicyModal"
        >
          | Privacy Policy
        </span>
      </b-col>
      <b-col
        cols="4"
        class="text-center"
      >
        Transreport limited. All rights reserved.
      </b-col>
      <b-col
        cols="4"
        class="text-right pr-0"
      >
        {{ appTitle }} v{{ version }}
      </b-col>
    </b-row>
  </footer>
</template>

<style lang="scss" scoped>
.modal-link {
  cursor: pointer;
}
</style>
